import { ERROR_RETRIEVING_SCAN_DETAILS_DATA, NO_RESULTS_SCAN_DETAILS_DATA, RECEIVE_SCAN_DETAILS_DATA, REQUEST_SCAN_DETAILS_DATA } from "../actions/scanDetailsDataActions";

const initialState = {
    scanDetails: [],
    noResults: false,
    isFetching: false
};

export default function (state = initialState, action) {

    switch (action.type) {

        case REQUEST_SCAN_DETAILS_DATA:
            return {
                ...state,
                isFetching: true
            };
        case RECEIVE_SCAN_DETAILS_DATA:
            return {
                ...state,
                scanDetails: action.payload.scanStatuses,
                isFetching: false
            };
        case NO_RESULTS_SCAN_DETAILS_DATA:
            return {
                ...state,
                noResults: true,
                isFetching: false
            };
        case ERROR_RETRIEVING_SCAN_DETAILS_DATA:
            return {
                ...initialState,
                error: action.payload,
                isFetching: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/scanDetailsReducer.js